var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question
    ? _c(
        "div",
        {
          staticClass:
            "form-question w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-lime-500 rounded-xl",
          attrs: { id: "question_field_" + _vm.question.id }
        },
        [
          _c("div", { staticClass: "w-128 mb-2 flex" }, [
            _c(
              "div",
              { staticClass: "flex-shrink-0 -mx-2" },
              [
                _c("BlSelectBox", {
                  attrs: {
                    placeholder: "Select input type",
                    options: _vm.inputTypeOptions,
                    dense: "",
                    borderless: ""
                  },
                  on: {
                    change: function($event) {
                      _vm.inputTypeInput = $event
                    }
                  },
                  model: {
                    value: _vm.inputTypeInput,
                    callback: function($$v) {
                      _vm.inputTypeInput = $$v
                    },
                    expression: "inputTypeInput"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.labelInput,
                expression: "labelInput"
              }
            ],
            staticClass: "label-area-input mb-2 focus:border-light-purple",
            attrs: {
              type: "text",
              name: "question_label_" + _vm.question.id,
              id: "question_label_" + _vm.question.id,
              placeholder: "Question label"
            },
            domProps: { value: _vm.labelInput },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.labelInput = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _vm.inputTypeInput === "text"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-7.5 w-128 px-2 flex items-center rounded border border-slate-500 bg-slate-200"
                  },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text: "The guardian will fill in the answer here."
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputTypeInput === "textarea"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-25 w-128 py-1 px-2 rounded border border-slate-500 bg-slate-200"
                  },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text: "The guardian will fill in the answer here."
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputTypeInput === "date"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-7.5 w-128 px-2 flex items-center rounded border border-slate-500 bg-slate-200"
                  },
                  [_c("BlTextBody2", { attrs: { text: "dd/mm/yyyy" } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputTypeInput === "radio" || _vm.inputTypeInput === "checkbox"
              ? _c(
                  "div",
                  { staticClass: "w-128 flex flex-col gap-2" },
                  [
                    _vm._l(_vm.inputOptionsInput, function(opt, idx) {
                      return _c(
                        "div",
                        {
                          key: idx,
                          staticClass: "relative flex items-center gap-2"
                        },
                        [
                          _vm.inputTypeInput === "radio"
                            ? _c("BlInputRadio", {
                                attrs: {
                                  name:
                                    "options_input_" +
                                    _vm.question.id +
                                    "_" +
                                    idx
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.inputTypeInput === "checkbox"
                            ? _c("BlInputCheck", {
                                attrs: {
                                  name:
                                    "options_input_" +
                                    _vm.question.id +
                                    "_" +
                                    idx
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            staticClass:
                              "option-label-input focus:border-light-purple",
                            attrs: {
                              type: "text",
                              name:
                                "options_label_" + _vm.question.id + "_" + idx,
                              id:
                                "options_label_" + _vm.question.id + "_" + idx,
                              placeholder: "Type the option here"
                            },
                            domProps: { value: _vm.inputOptionsInput[idx] },
                            on: {
                              input: function($event) {
                                return _vm.onInputOption(
                                  idx,
                                  opt,
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: {
                              type: "outlined-error",
                              dense: "",
                              icon: "delete"
                            },
                            on: {
                              clicked: function($event) {
                                return _vm.onRemoveOption(idx)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.isUseOtherInput
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _vm.inputTypeInput === "radio"
                              ? _c("BlInputRadio", {
                                  attrs: {
                                    name:
                                      "options_input_" +
                                      _vm.question.id +
                                      "_other"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputTypeInput === "checkbox"
                              ? _c("BlInputCheck", {
                                  attrs: {
                                    name:
                                      "options_input_" +
                                      _vm.question.id +
                                      "_other"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-slate-800",
                              attrs: { text: "Other:" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-7.5 px-2 flex items-center rounded border border-slate-500 bg-slate-200",
                                style: { width: "27.5rem" }
                              },
                              [
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "The guardian will fill in the answer here."
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              attrs: {
                                type: "outlined-error",
                                dense: "",
                                icon: "delete"
                              },
                              on: { clicked: _vm.onRemoveUseOther }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "h-7.5 flex items-center gap-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cursor-pointer",
                            on: { click: _vm.addOption }
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass:
                                "h-7.5 flex items-center text-light-purple hover:text-dark-purple-200",
                              attrs: { text: "Add option" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isUseOtherInput
                          ? _c("BlTextBody2", {
                              staticClass: "text-slate-800",
                              attrs: { text: "or" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isUseOtherInput
                          ? _c(
                              "div",
                              {
                                staticClass: "cursor-pointer",
                                on: { click: _vm.addUseOther }
                              },
                              [
                                _c("BlTextSubtitle3", {
                                  staticClass:
                                    "h-7.5 flex items-center text-light-purple hover:text-dark-purple-200",
                                  attrs: { text: "Add Other" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.question.data_field
            ? _c(
                "div",
                {
                  staticClass:
                    "w-128 flex items-center justify-start flex-wrap gap-2"
                },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "The answer will be recorded in the" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-5.5 px-1.5 flex items-center rounded bg-slate-300"
                    },
                    [
                      _c("BlTextBody2", {
                        attrs: { text: _vm.question.data_field.label }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-774cdf7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-774cdf7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/salesPipeline/parentForm/Question.vue
// module id = null
// module chunks = 